import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent {
  @Input() data: any[] = [];
  @Input() loading: boolean = false;
  @ContentChild('headerTemplate') headerTemplate!: TemplateRef<any>;
  @ContentChild('rowTemplate') rowTemplate!: TemplateRef<any>;
  @ContentChild('emptyTemplate') emptyTemplate!: TemplateRef<any>;
} 